import Raven from 'raven-js';

if (process.env.NODE_ENV === 'production') {
  const DNS_STAGING =
    'https://74506b42970140c4927a14dce6923dce@sentry.io/284520';
  const DNS_PRODUCTION =
    'https://788f5cd8f7e142dbbfbebcd10b01567f@sentry.io/284519';

  const DOMAINS_PRODUCTION = [
    'www.findacarer.com.au',
    'mycsn.sydney.near-me.com'
  ];

  if (DOMAINS_PRODUCTION.indexOf(window.location.host) > -1) {
    Raven.config(DNS_PRODUCTION).install();
  } else {
    Raven.config(DNS_STAGING).install();
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/services/initializeErrorReporting.js